module.exports = __webpack_public_path__ + "static/media/R-PANELv6.6-RC1/arrowUp.43eb9f50.svg";